import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SigmecErrorsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      date: null,
      modal: false,
      data_modal: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.formatRequest = this.formatRequest.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/erros', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  formatRequest (cell, row) {
    var json = cell;
    try {
      json = JSON.parse(cell);
      json = JSON.stringify(json, null, '\t');
    } catch (e) {
    }

    return <button className="btn btn-primary" onClick={() => { this.openModal(json); }}>Ver request</button>;
  }

  openModal(json) {
    console.log(json);
    this.setState({modal: true, data_modal: json});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Erros - SIGMEC</h3>
      <hr/>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há tripulantes cadastrados', defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar' expandComponent={ this.expandComponent } expandableRow={ this.expandableRow }>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="user" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Usuário</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Ação</TableHeaderColumn>
        <TableHeaderColumn dataField="method" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Método</TableHeaderColumn>
        <TableHeaderColumn dataField="request" dataFormat={this.formatRequest} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Request</TableHeaderColumn>
        <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Request detalhado</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <pre>{this.state.data_modal}</pre>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default SigmecErrorsIndex;



// WEBPACK FOOTER //
// ./src/Components/Sigmec/SigmecErrorsIndex.js